import React from 'react';
import { Link } from '@fiverr-private/typography';
import { NicheCardProps } from '../NicheCard.types';
import { NicheCardContent } from '../NicheCardContent';
import { BUTTON_IMAGE_SIZE } from '../NicheCard.constants';
import { linkCard } from '../NicheCard.ve.css';

export const NicheCardButton: React.FC<NicheCardProps> = ({ displayName, url, isSelected = false, onClick }) => (
    <Link
        className={linkCard}
        onClick={onClick}
        decoration={{ default: isSelected ? 'underline' : 'none', hover: 'underline' }}
        cursor="pointer"
    >
        <NicheCardContent displayName={displayName} url={url} imageSize={BUTTON_IMAGE_SIZE} isSelected={isSelected} />
    </Link>
);

NicheCardButton.displayName = 'NicheCardButton';
